import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { authRoutes } from 'src/app/features/auth/shared/auth-routes';
import { AuthService } from 'src/app/features/auth/shared/services/auth.service';
import { AlertId } from '../services/alert.service';
import { AuthRepository } from 'src/app/features/auth/store/auth.repository';
import { AppConfig } from 'src/app/configs/app.config';
import { ERROR_CODE_401 } from 'src/environments/constants';

@Injectable({
  providedIn: 'root',
})
export class AuthHttpInterceptor {
  window: Window;

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly authRepository: AuthRepository,
    private readonly document: Document
  ) {
    this.window = this.document.defaultView as Window;
  }


  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const accessToken = this.authRepository.getResponseToken()?.token || '';
    const clvs = this.authRepository.getResponseToken()?.clvs || '';
    const dateRandom = Date.now().toString();

    if (!accessToken || req.headers.get(AppConfig.bypassAuthorization)) {
      const basicRequest = req.clone({ setHeaders: { req_uuid: dateRandom } });
      return next.handle(basicRequest);
    }

    const isAccessTokenExpired = false;
    if (isAccessTokenExpired) {
      this.navigateToLogout();
      return observableThrowError(() => new Error('Session expired'));
    }
    const authorizedRequest = req.clone({
      setHeaders: {
        req_uuid: dateRandom,
        Authorization: `Bearer ${accessToken}`,
        Cxzclvs: clvs,
      }
    });

    return next.handle(authorizedRequest).pipe(
      map(response => {
        this.checkUnAuthorizedError(response);
        return response;
      }),
      catchError(error => observableThrowError(() => new Error(error)))
    );
  }


  checkUnAuthorizedError(response: unknown) {
    if (response instanceof HttpResponse) {
      const bodyErrors = response.body.errors;
      if (bodyErrors?.length) {
        const unAuthorizeErrorFounded = bodyErrors.find(
          (bodyError: { code: number }) => bodyError.code === ERROR_CODE_401
        );
        if (unAuthorizeErrorFounded) {
          this.navigateToLogout();
        }
      }
    }
  }

  sendRequest(
    request: HttpRequest<unknown>,
    next: HttpHandler,
    headers: { req_uuid: string; Authorization: string }
  ) {
    const newRequest = request.clone({ setHeaders: headers });
    return next.handle(newRequest).pipe(
      map(response => {
        this.checkUnAuthorizedError(response);
        return response;
      }),
      catchError(error => {
        throw new Error(error);
      })
    );
  }

  navigateToLogout() {
    this.router.navigate([authRoutes.logout], {
      queryParams: {
        origin: encodeURIComponent(this.window.location.href),
        alertId: AlertId.SESSION_EXPIRED,
      },
    });
  }
}
